import { useEffect, useState } from "react"
import { Fab, Tooltip, Zoom } from "@mui/material"
import WhatsAppIcon from "@mui/icons-material/WhatsApp"

import { getSiteConfig } from "../api/siteConfigApi"
import { WHATSAPP_E164, WHATSAPP_HREF } from "../constants/contactInfo"
import { homeCopy } from "../content/homeCopy"

const buildWhatsAppUrl = (baseUrl) => {
    const prompt = homeCopy?.whatsapp?.chatPrompt
    if (!prompt) return baseUrl || WHATSAPP_HREF
    const url = new URL(baseUrl || WHATSAPP_HREF)
    url.searchParams.set("text", prompt)
    return url.toString()
}

const resolveWhatsAppConfig = (siteConfig) => {
    const remote = siteConfig?.whatsapp
    if (remote) {
        return {
            enabled: Boolean(remote.enabled),
            url: buildWhatsAppUrl(remote.url || `https://wa.me/${WHATSAPP_E164}`),
        }
    }

    const legacy = siteConfig?.facebookMessenger
    if (legacy) {
        return {
            enabled: Boolean(legacy.enabled),
            url: buildWhatsAppUrl(WHATSAPP_HREF),
        }
    }

    return {
        enabled: true,
        url: buildWhatsAppUrl(WHATSAPP_HREF),
    }
}

/** Fixed WhatsApp chat button — opens wa.me to the business number. */
const WhatsAppChat = () => {
    const [config, setConfig] = useState(null)

    useEffect(() => {
        let cancelled = false

        getSiteConfig()
            .then((data) => {
                if (!cancelled) setConfig(resolveWhatsAppConfig(data))
            })
            .catch(() => {
                if (!cancelled) setConfig(resolveWhatsAppConfig(null))
            })

        return () => {
            cancelled = true
        }
    }, [])

    if (!config || !config.enabled) {
        return null
    }

    return (
        <Zoom in>
            <Tooltip title="Message us on WhatsApp" placement="left">
                <Fab
                    component="a"
                    href={config.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Message Stargate Rentals on WhatsApp"
                    sx={{
                        position: "fixed",
                        right: { xs: 16, md: 24 },
                        bottom: { xs: 16, md: 24 },
                        zIndex: 1300,
                        bgcolor: "#25D366",
                        color: "#fff",
                        boxShadow: "0 12px 32px rgba(37, 211, 102, 0.4)",
                        "&:hover": {
                            bgcolor: "#1EBE57",
                        },
                    }}
                >
                    <WhatsAppIcon sx={{ fontSize: 28 }} />
                </Fab>
            </Tooltip>
        </Zoom>
    )
}

export default WhatsAppChat
